import { PRODUCT } from '@/consts';
import { EcommerceSchema } from '@/features/ecommerce/stepsSchema';
import { HHSchema } from '@/features/v2/hh/stepsSchema';
import { ExtendedSteps } from '@/features/v2/lib/wizard';
import { VehicleDamageSchema } from '@/features/v2/vehicle-damage/stepsSchema';

type ProductMapType = {
  [key: number]: ExtendedSteps[];
};

export const PRODUCT_MAP: ProductMapType = {
  [PRODUCT.VEHICLE_DAMAGE]: VehicleDamageSchema, // VEHICLE_DAMAGE
  [PRODUCT.VEHICLE_DAMAGE_TRANSPORT]: VehicleDamageSchema, // VEHICLE_DAMAGE_TRANSPORT
  [PRODUCT.HOUSE_HOLD]: HHSchema, // HOUSE_HOLD
  [PRODUCT.TRANSMISSION]: EcommerceSchema, // TRANSMISSION
};
